'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactKeyHandler = require('react-key-handler');

var _reactKeyHandler2 = _interopRequireDefault(_reactKeyHandler);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _windowScrollBlocker = require('../../libs/windowScrollBlocker');

var _windowScrollBlocker2 = _interopRequireDefault(_windowScrollBlocker);

var _Card = require('../Card/Card');

var _Card2 = _interopRequireDefault(_Card);

var _Portal = require('../Portal/Portal');

var _Portal2 = _interopRequireDefault(_Portal);

var _Container = require('./components/Container.Modal');

var _Container2 = _interopRequireDefault(_Container);

var _Card3 = require('./components/Card.Modal');

var _Card4 = _interopRequireDefault(_Card3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Libs
// Components


var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.freeScroll = null, _this.closeActionButton = function () {
      return {
        icon: 'close',
        onClick: _this.onClose,
        disabled: !_this.props.closable
      };
    }, _this.onClose = function () {
      var _this$props = _this.props,
          visible = _this$props.visible,
          onClose = _this$props.onClose,
          closable = _this$props.closable;
      if (!visible || !closable) return;
      onClose();
    }, _this.headerActions = function () {
      return _this.props.headerActions ? [].concat(_toConsumableArray(_this.props.headerActions), [_this.closeActionButton()]) : [_this.closeActionButton()];
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleWindow(false, this.props.visible);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this.handleWindow(prevProps.visible, this.props.visible);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleWindow(true, false);
    }
  }, {
    key: 'handleWindow',
    value: function handleWindow(previousShow, currentShow) {
      if (!previousShow && currentShow) {
        this.freeScroll = _windowScrollBlocker2.default.add();
      } else if (previousShow && !currentShow && this.freeScroll) {
        this.freeScroll();
        (0, _jquery2.default)(':focus').blur();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          visible = _props.visible,
          onClose = _props.onClose,
          children = _props.children,
          size = _props.size,
          props = _objectWithoutProperties(_props, ['visible', 'onClose', 'children', 'size']);

      return _react2.default.createElement(_Portal2.default, {
        always: true
      }, _react2.default.createElement(_Container2.default, {
        visible: visible
      }, visible && props.closable && _react2.default.createElement(_reactKeyHandler2.default, {
        keyEventName: 'keydown',
        keyValue: 'Escape',
        onKeyHandle: this.onClose
      }), _react2.default.createElement(_Card4.default, {
        size: size,
        visible: visible,
        onClose: this.onClose
      }, _react2.default.createElement(_Card2.default, _extends({}, props, {
        headerActions: this.headerActions(),
        shadow: true
      }), function (component) {
        return children(component);
      }))));
    }
  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  visible: _propTypes2.default.bool.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.func.isRequired,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'full']),
  closable: _propTypes2.default.bool
};
Modal.defaultProps = {
  size: 'medium',
  closable: true
};
exports.default = Modal;